module.exports = __webpack_public_path__ + "static/parade-2019-house05-fbe2f5a1fbc27f6a713ba3b183dc89ed.jpg";